import './item-adder.scss';
import React, { useEffect } from "react";
import { BreakdownWindow } from "../../../../../theming/breakdown-window";
import { ItemsView } from '../../../../../characters/items/ItemsView';
import { LocalCharacterInitializer } from '../../../../../../entities/characters/Character';
import { useAppDispatch, useAppSelector } from '../../../../../../store/configureStore';
import { LibraryActions } from '../../../../../../store/stores/library/LibraryStore.Actions';

type Props = {
    character: LocalCharacterInitializer;
    visible: boolean;
    close: () => void;
}

export const ItemAdder: React.FC<Props> = (props: Props) => {
    const { character, visible, close } = props;
    const dispatch = useAppDispatch();
    const { allItemsLoaded } = useAppSelector(app => app.library);

    useEffect(() => {
        if (!allItemsLoaded) {
            dispatch(LibraryActions.loadItems());
        }
    }, [allItemsLoaded]);

    return (
        <BreakdownWindow className="item-adder" heading={<h1>Add Item to Inventory</h1>} visible={visible} close={close}>
            <ItemsView character={character} useRoute={false} close={close} />
        </BreakdownWindow>
    );
}